module.exports = __webpack_public_path__ + "1791188489487/images/fa-brands-400.83e6c29.svg";